export function mergeWithApplicationState(pageTags, responseApplicationState) {
    let applicationState = responseApplicationState;

    return applicationState;
}
